import React from 'react';
import { connect } from 'react-redux';
import { getSafe } from '@/helpers/global';
import icon_check_normalIcon from '@/assets/images/icons/icon_check_normal.png'
import icon_check_hitIcon from '@/assets/images/icons/icon_check_hit.png'
import { tipsType } from '@/constants/tips-type';
import Dropdown from '@/components/Dropdown/Dropdown'
import { lang } from 'moment';
import { utilsFunction } from '@/helpers/functions'
class Apply extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      sharesApply: [
        {
          value: '1000',
          label: '1000'
        },
        {
          value: '2000',
          label: '2000'
        },
      ],
      fee: '',
      subscriptionAmount: '',
      remark: '',
      priceBottomData: [],
      showBottomData: [],
      amountPrice: ''
    }
  }

   dateFormat = (date) => {
    return date.replace(/\//g, '').replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1')
  }

  selectNumberShares = (val) => {
    let data = [], data2 = [];
    const {remark,handlingFee} = this.props.applyDataResp
    let { appliedQty, overrideAmount } = val[0]
    data = [
      { label: 'common_number_of_shares_applied', value: utilsFunction.currencyFormatter(appliedQty, 0) },
      { label: 'common_subscription_amount', value: utilsFunction.formatNumber(overrideAmount,2) },
      { label: 'ipo_service_charge', value: utilsFunction.formatNumber(handlingFee,2) },
      { label: 'ipo_remark', value: remark ? remark : '-' },
    ]
    data2 = [
      { label: 'ipo_service_charge', value: utilsFunction.formatNumber(handlingFee,2) },
      { label: 'common_subscription_amount', value: utilsFunction.formatNumber(overrideAmount,2) },
      { label: 'ipo_remark', value: remark ? remark : '-' },
    ]
    this.setState({
      showBottomData: data2
    }, () => {
      let a = overrideAmount * 1000 + handlingFee * 1000
      this.setState({
        priceBottomData: data,
        amountPrice: a / 1000,
        subscriptionAmount: appliedQty
      })
    })

  }

  reSetSharesApply() {
    this.selectNumberShares([this.props.lotSpreadList[0]])
    this.lotSpread.setValue([this.props.lotSpreadList[0]])
  }

  componentDidMount() {
    this.selectNumberShares([this.props.lotSpreadList[0]])
  }

  render() {
    const { language, priceData, lotSpreadList } = this.props;
    const { priceBottomData, amountPrice, showBottomData } = this.state;
    return (
      <React.Fragment>
        <section className='price-container'>
          <div className="table-box">
            {
              priceData && priceData.map((data, index) =>
                <div className="row" key={index}>
                  <div className="key">{getSafe(() => language[data.label])}</div>
                  <div className="value">{data.value}</div>
                </div>
              )
            }
          </div>
          <div className="table-box">
            <div className="row">
              <div className="key">{getSafe(() => language.common_number_of_shares_apply)}<span className="required">*</span></div>
              <div className="value">
                <Dropdown
                  style={{ height: '100%' }}
                  selectedOptions={[lotSpreadList[0]]}
                  options={lotSpreadList}
                  onChange={(val) => this.selectNumberShares(val)}
                  innerRef={(e) => this.lotSpread = e}
                ></Dropdown>
              </div>
            </div>
            {
              showBottomData.map((item) =>
                <div className="row" key={item.label + item.value}>
                  <div className="key">{getSafe(() => language[item.label])}</div>
                  <div className="value">{item.value}</div>
                </div>
              )
            }
          </div>
          <div className="total-amount-price">
            {getSafe(() => language.common_total_amount_of_payment)}: <span className="price">{utilsFunction.formatNumber(amountPrice,2)} HKD</span>
          </div>
        </section>
      </React.Fragment>
    )
  }
}

Apply.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(Apply)
